export const typography = {
  fontFamily: '"Red Hat Text", sans-serif',
  h1: {
    fontWeight: 500,
    fontSize: '36px',
    lineHeight: '48px',
  },
  h2: {
    fontWeight: 400,
    fontSize: '48px',
    lineHeight: '56px',
    letterSpacing: '-0.5px',
  },
  h3: {
    fontWeight: 400,
    fontSize: '40px',
    lineHeight: '48px',
    letterSpacing: '0px',
  },
  h4: {
    fontWeight: 400,
    fontSize: '34px',
    lineHeight: '44px',
    letterSpacing: '0.25px',
  },
  h5: {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '32px',
    letterSpacing: '0.15px',
  },
  body1: {
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '26px',
    // letterSpacing: '0.15px',
  },
  body2: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
  },
  caption: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.4px',
    textAlign: 'center',
  },
  overline: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '1px',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
};
